// Место для имени резервируется до добавления необязательных кнопок.
export function headerCallCount(width: number, requiredWidth: number, buttonWidth: number): number {
  if (buttonWidth <= 0) return 0;
  return Math.max(0, Math.min(2, Math.floor((width - requiredWidth) / buttonWidth)));
}
